import { Group, Input, TextField as AriaTextField } from 'react-aria-components';
import { Search } from 'lucide-react';
import { FieldFoot, FieldLabel, cx, fieldClass } from './parts';
import type { TextFieldProps } from './types';
import './styles';

/**
 * Однострочное поле. Вид — `ac-trigger`, как у списка и даты: рамка, высота
 * 42/32 px, фокус. Нативного `<input>` в разметке страницы нет — он живёт
 * внутри React Aria и получает подпись, подсказку и ошибку по контексту.
 */
export function TextField({ label, 'aria-label': ariaLabel, explain, description, errorMessage, isInvalid, isRequired, isDisabled, size = 'md', className, value, onChange, placeholder, type = 'text', maxLength, autoComplete, inputMode }: TextFieldProps) {
  return (
    <AriaTextField
      className={fieldClass(size, className)}
      value={value}
      onChange={onChange}
      type={type}
      maxLength={maxLength}
      autoComplete={autoComplete}
      inputMode={inputMode}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      validationBehavior="aria"
      aria-label={label ? undefined : ariaLabel}
    >
      <FieldLabel label={label} ariaLabel={ariaLabel} explain={explain} isRequired={isRequired} />
      <Group className={cx('ac-trigger', 'fm-input')} isDisabled={isDisabled} isInvalid={isInvalid}>
        {type === 'search' ? <Search size={15} className="fm-icon" aria-hidden /> : null}
        <Input placeholder={placeholder} />
      </Group>
      <FieldFoot description={description} errorMessage={errorMessage} isInvalid={isInvalid} />
    </AriaTextField>
  );
}
